import { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { subscribeSubmitForm } from '~/utils'
import schema from '~/validation/schemas/form.schema'

import { yupResolver } from '@hookform/resolvers/yup'

import 'react-toastify/dist/ReactToastify.min.css'

type SubscribeFV = {
  name: string
  email: string
}

type useSubscribeFormProps = {
  onSubmitSuccess?: () => void
}

export const useSubscribeForm = ({
  onSubmitSuccess = () => {},
}: useSubscribeFormProps = {}) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const defaultValues = {
    name: '',
    email: '',
  }

  const methods = useForm<SubscribeFV>({
    resolver: yupResolver(schema.subscribe),
    defaultValues,
  })

  const { reset, handleSubmit } = methods

  const onSubmit = useCallback(
    async (data) => {
      if (!executeRecaptcha) {
        toast.error('Failed to get reCAPTCHA token', {
          position: toast.POSITION.TOP_RIGHT,
        })
        return
      }

      const token = await executeRecaptcha()

      if (!token) {
        toast.error('Failed to get reCAPTCHA token', {
          position: toast.POSITION.TOP_RIGHT,
        })
        return
      }

      await subscribeSubmitForm(data, reset)

      if (onSubmitSuccess) {
        onSubmitSuccess()
      }
    },
    [executeRecaptcha, onSubmitSuccess, reset],
  )

  return { methods, handleSubmit, onSubmit }
}
